function quicklinks(quicklinksSelector) {
    if (!$(quicklinksSelector).length) return;

    // Leere Quicklinks entfernen
    $('body:not(#editMode) '+quicklinksSelector + '>ul>li .quicklinks_box_content, '+
        'body:not(#editMode) '+quicklinksSelector + '>ul>li .quicklinks_icons_content').each(function() {
        if ($(this).text().trim() === '') {
            $(this).parent().remove();
        }
    });

    // Quicklinks Leiste beim Laden einfahren lassen
    $(quicklinksSelector).addClass('show');


    // Touch Hover
    $(quicklinksSelector + '>ul>li').each(function () {
        $(this).on("touchstart", function (e) {
            if (!$(this).hasClass('hover')) {
                $(this).addClass('hover');
                e.preventDefault();
                $(this).siblings().each(function () {
                    $(this).removeClass('hover');
                });
                return false;
            }
            return true;
        });
    });


    // Wieder entfernen, wenn man woanders hin klickt
    $(document).on("touchstart", function (e) {
        if ($(e.target).is(quicklinksSelector + '>ul>li') === false) {
            $(quicklinksSelector + '>ul>li').each(function () {
                $(this).removeClass('hover');
            });
        }
    });
}